// ============================================================================
// SELECTION SORT - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'selection-sort',
  name: 'Selection Sort',
  category: 'Sorting',
  complexity: {
    time: 'O(n²)',
    space: 'O(1)'
  },
  description: 'A simple comparison-based sorting algorithm that divides the input into a sorted and an unsorted region. It repeatedly selects the smallest element from the unsorted region and moves it to the sorted region.'
};
